import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import PageBuilder from '~/components/Layout/Builders/PageBuilder';
import { Logger } from '~/utilities/logger';
import GalleryCards from '~/components/Layout/Body/Page/GalleryCards';
import Title from '~/components/Layout/Body/Page/Title';
import Image from '~/components/Layout/Body/Page/Image';
import Gallery from '~/components/Layout/Body/Page/Gallery';
import Section from '~/components/Layout/Body/Page/Section';
import SectionHeader from '~/components/Layout/Body/Page/SectionHeader';
import Button from '~/components/Layout/Body/Page/Button';
import ButtonGroup from '~/components/Layout/Body/Page/ButtonGroup';
import Breadcrumbs from '~/components/Layout/Body/Page/Breadcrumbs';
import Card from '~/components/Layout/Body/Page/Card';
import HtmlEmbed from '~/components/Layout/Body/Page/HtmlEmbed';
import GalleryColumn from '~/components/Layout/Body/Page/GalleryColumn';
import type { PageBuilderBlockType } from '~/types/AppData/PageBuilder/PageBuilderBlockType';
import Carousel from '~/components/Layout/Body/Page/Carousel';
import AuthorRail from '~/components/Layout/Body/Page/AuthorRail';
import AuthorCard from '~/components/Layout/Body/Page/AuthorCard';
import HTML from '~/components/Layout/Body/Page/HTML';
import AdBlock from '~/components/Layout/Body/Page/AdBlock';
import SponsorBlock from '~/components/Layout/Body/Page/SponsorBlock';
import Heading from '~/components/Layout/Body/Page/Heading';
import VoltaxVideo from '~/components/Layout/Body/Page/VoltaxVideo';
import Spacer from '~/components/Layout/Body/Page/Spacer';
import SportradarBlock from '~/components/Layout/Body/Page/SportradarBlock';
import TopAdBlock from '~/components/Layout/Body/Page/TopAdBlock';
import FeedVideoPlaylist from '~/components/Layout/Body/Page/FeedVideoPlaylist';

const componentMap: Record<string, any> = {
  GalleryCards,
  Title,
  Image,
  Gallery,
  Section,
  SectionHeader,
  GalleryColumn,
  Card,
  Button,
  ButtonGroup,
  Breadcrumbs,
  Carousel,
  AuthorRail,
  AuthorCard,
  HTML,
  HtmlEmbed,
  Ad: AdBlock,
  Sponsor: SponsorBlock,
  TopAd: TopAdBlock,
  Heading,
  VoltaxVideo,
  Spacer,
  Sportradar: SportradarBlock,
  FeedVideoPlaylist,
};

type SinglePageItemType = {
  item: PageBuilderBlockType;
  index: number;
};

export default component$<SinglePageItemType>(
  ({ item, index }): JSX.Element => {
    const Component = componentMap[item.type] || null;
    if (!Component) {
      new Logger().error('Page builder item not found: ' + item.type);
      return <></>;
    }

    return item.children ? (
      <Component
        {...item.props}
        content={item.content}
        items={item.children}
        index={index}
      >
        <PageBuilder items={item.children} />
      </Component>
    ) : (
      <Component
        {...item.props}
        content={item.content}
        items={item.children}
        index={index}
      />
    );
  }
);
